var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilters(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 2,
    x2: 13,
    y2: 2,
    stroke: "#8C8D8E",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: 12,
    x2: 13,
    y2: 12,
    stroke: "#8C8D8E",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 7,
    x2: 7,
    y2: 7,
    stroke: "#8C8D8E",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 2,
    x2: 20,
    y2: 2,
    stroke: "#8C8D8E",
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 12,
    x2: 20,
    y2: 12,
    stroke: "#8C8D8E",
    strokeWidth: 2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 7,
    x2: -8.74228e-8,
    y2: 7,
    stroke: "#8C8D8E",
    strokeWidth: 2
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    x2: 15,
    y2: 4,
    stroke: "#8C8D8E",
    strokeWidth: 2
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 10,
    x2: 15,
    y2: 14,
    stroke: "#8C8D8E",
    strokeWidth: 2
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 9,
    x2: 5,
    y2: 5,
    stroke: "#8C8D8E",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilters);
export default __webpack_public_path__ + "static/media/filters.2df614905fd3bd30892026db4c667f14.svg";
export { ForwardRef as ReactComponent };